import {EngagementId, EngagementJoinLink} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function get(engagementId: EngagementId): Promise<EngagementJoinLink | null> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/engagements/{engagement_id}/join_link", {
    path: {engagement_id: engagementId},
  });
}

export async function rotate(engagementId: EngagementId): Promise<EngagementJoinLink> {
  const link = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/engagements/{engagement_id}/join_link",
    {path: {engagement_id: engagementId}},
  );
  await invalidateQueries([q.tprm.engagementJoinLink.filter(engagementId)]);
  return link;
}

export async function delete_(engagementId: EngagementId) {
  await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/engagements/{engagement_id}/join_link", {
    path: {engagement_id: engagementId},
  });
  await invalidateQueries([q.tprm.engagementJoinLink.filter(engagementId)]);
}
